import { PRACTITIONER_SPECIALTIES } from '../../constant'

const getPrefixes = (): string[] => (
  Object.keys(PRACTITIONER_SPECIALTIES)
)

// if does not match to a specialty, return ''
export function expandSpecialtyFilter(filterAbbreviation: string) {
  // we use startsWith because we only use the prefix as keys
  const fn = (k: string): string => (
    filterAbbreviation.startsWith(k)
      ? PRACTITIONER_SPECIALTIES[k as keyof typeof PRACTITIONER_SPECIALTIES]
      : ''
  )
  return getPrefixes().map(fn).join('')
}

export function specialtyFilterKeys() {
  return getPrefixes().sort()
}
